import { reservationsConstants } from '../constants'

const initialState = {
  loading: false,
  list: null
}

export default function reservations(state = initialState, action) {
  switch (action.type) {
    case reservationsConstants.RESERVATIONS_UPDATE:
      return {
        ...state,
        list: (state.list === null
          ? [action.payload]
          : state.list.findIndex((x) => x.id === action.payload.id) === -1
          ? state.list.concat(action.payload)
          : state.list.map((item) => {
              return item.id === action.payload.id ? action.payload : item
            })
        ).sort((a, b) => (a.date < b.date ? -1 : 1))
      }
    case reservationsConstants.RESERVATIONS_REMOVE:
      return {
        ...state,
        list: state.list
          .filter((item) => {
            return item.id !== action.payload.id
          })
          .sort((a, b) => (a.date < b.date ? -1 : 1))
      }
    case reservationsConstants.RESERVATIONS_BOOK:
      return { ...state, loading: true }
    case reservationsConstants.RESERVATIONS_BOOK_SUCCESS:
    case reservationsConstants.RESERVATIONS_BOOK_FAILURE:
      return { ...state, loading: false }
    default:
      return state
  }
}
